import RestService from '../services/rest';

async function createWizard(user) {
  return RestService.postRest('wizard/create', user);
}

export default {
  createWizard,
};
